// extracted by mini-css-extract-plugin
module.exports = {"container":"captcha_container__1GG_J","captchaWrapper":"captcha_captchaWrapper__PBPC4","iconWrapper":"captcha_iconWrapper__3_pCE","icon":"captcha_icon__3aI8o"};